import { useNavigate, useParams } from 'react-router-dom';
import { useGetOrderQuery } from '../services';
import { useRole } from 'hooks/useRole';
import { ResponseOrderDto } from '../types/dtos';

const useController = () => {
    const { orderId } = useParams();
    const { data: order } = useGetOrderQuery(orderId as string);
    const { isAdmin } = useRole();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return {
        order: order as ResponseOrderDto,
        isLoading: order === undefined,
        isAdmin,
        handleBack,
    };
};
export default useController;
